import { CasinoAdModel } from 'v2/types/AdModel';

export type CasinoAdForm = Omit<CasinoAdModel, 'id'>;

export const initialValues: CasinoAdForm = {
  name: '',
  adId: '',
  casinoId: '',
  additionalValue: '',
  isActive: false,
  image390Id: null,
  image768Id: null,
  image1024Id: null,
  image1300Id: null,
  isVideo: false,
};
